import { api } from '../api';
import type {
  FetchCheckoutRequirementsRequest,
  QuickCheckoutRequest,
  StoreCheckoutRequirements,
} from './quickCheckout.types';

const quickCheckoutUrls = {
  checkout: '/v1/carts/checkout',
};

export const fetchCheckoutRequirements = async ({
  storeId,
  reservationMode,
  appMode,
  jwt,
}: FetchCheckoutRequirementsRequest) => {
  const query = new URLSearchParams();
  if (reservationMode) query.set('reservation_mode', reservationMode);
  if (appMode) query.set('app_mode', appMode);
  const queryString = query.toString();
  const url = `/v1/stores/${storeId}/checkout_requirements${
    queryString ? `?${queryString}` : ''
  }`;

  return api.get<StoreCheckoutRequirements>(url, jwt);
};
export const createQuickCheckout = ({
  jwt,
  ...checkout
}: QuickCheckoutRequest) => {
  const checkoutPayload = {
    ...checkout,
    //quick checkout is only available for aeropay users, so we can hardcode these values for now
    aeropay_account_verified: true,
    payment_method: 'jane_pay',
  };

  return api.post(quickCheckoutUrls.checkout, checkoutPayload, jwt);
};
